var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fm-table-menu"},_vm._l((_vm.tableActions),function(item){return _c('fm-btn',{key:item.key,attrs:{"btn-label":item.label || item.getLabel(_vm.rowData),"btn-status":item.status,"btn-size":"small"},on:{"clickBtn":function($event){return _vm.clickFmTableMenu(item.key)}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-394a6b9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components_bit/FmTableMenu.vue
// module id = null
// module chunks = 